// Asks the server for Help (UC-36). The answer holds a link to each video
// that works for fifteen minutes, so the screen asks again rather than keeping
// an old answer: when it opens, after Retry, and when a link has run out.

import { api } from '../api/client';
import type { Language } from '../i18n/messages';
import { shelfOf, type HelpSection } from './shelf';

export type HelpAnswer =
	| { kind: 'shelf'; sections: HelpSection[] }
	/**
	 * No answer. Retry is offered only when trying again can help: the
	 * network failed or the server did (5xx). A refusal, or a server from
	 * before Help (404), answers the same however often it is asked.
	 */
	| { kind: 'failed'; retry: boolean };

export async function loadHelp(language: Language): Promise<HelpAnswer> {
	try {
		const { data, response } = await api.GET('/api/owner/help', {
			params: { query: { language } },
		});
		if (data) return { kind: 'shelf', sections: shelfOf(data.sections) };
		return { kind: 'failed', retry: response.status >= 500 };
	} catch {
		return { kind: 'failed', retry: true };
	}
}
